import type { PayexThunkAction } from 'store/configureStore';

import {
  CHINA_COUNTRY_CODE,
  EXCHANGE_CURRENCY_REQUEST,
  EXCHANGE_CURRENCY_SUCCESS,
} from 'constants/index';
import {
  getCurrentCountryCode,
  getCurrentCurrency,
  getTotalAmount,
} from 'selectors';

import { exchange } from 'services/exchange/exchange';

export const exchangeCurrency =
  (): PayexThunkAction => async (dispatch, getState) => {
    const state = getState();
    const countryCode = getCurrentCountryCode(state);
    if (countryCode !== CHINA_COUNTRY_CODE) {
      return;
    }

    dispatch({
      type: EXCHANGE_CURRENCY_REQUEST,
    });

    const { code: currencyFrom } = getCurrentCurrency(state);
    const totalAmount = getTotalAmount(state);

    const response = await exchange.fetch({
      totalAmount,
      currencyTo: 'USD',
      currencyFrom,
    });

    dispatch({
      type: EXCHANGE_CURRENCY_SUCCESS,
      payload: response,
    });
  };
